import { makeStyles, Tabs, Tab, Chip } from '@material-ui/core';
import { colorSet } from '@components/Provider';
import useQueryString from '@hooks/useQueryString';
import { useHistory } from 'react-router-dom';
import { useSelector } from '@store';
import { useFetchQuotationUserRfqAvailableReviewsQuery } from '@generated/graphql';

const ReviewTabs = () => {
  const classes = useStyles();
  const history = useHistory();
  const id = useSelector((state) => state.client.id);

  const {
    query: { type }
  } = useQueryString();

  const { data } = useFetchQuotationUserRfqAvailableReviewsQuery({
    variables: {
      input: {
        quotationUserId: id
      }
    },
    fetchPolicy: 'cache-first',
    skip: !id
  });

  const count =
    data?.fetchQuotationUserRfqAvailableReviews.data?.availableReviewCount ?? 0;

  return (
    <div className={classes.tabs}>
      <Tabs
        value={type ?? 'writeable'}
        onChange={(_, value) => {
          history.push(`${history.location.pathname}?type=${value}`);
        }}
      >
        <Tab
          value="writeable"
          label={
            <span>
              작성 가능한 리뷰&nbsp;
              <Chip className={classes.chip} label={count} />
            </span>
          }
        />
        <Tab value="written" label="작성한 리뷰" />
      </Tabs>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  chip: {
    borderRadius: '50%',
    backgroundColor: colorSet.errorBase,
    minWidth: 20,
    height: 20,
    padding: 0,
    marginLeft: 6,
    '& > span': {
      ...theme.typography.caption,
      color: colorSet.gray000,
      padding: '0px 2px'
    }
  },
  tabs: {
    marginBottom: 20,
    borderBottom: `1px solid ${colorSet.gray200}`,
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px',
      position: 'sticky',
      top: 49,
      zIndex: 1010,
      backgroundColor: colorSet.gray000,
      marginBottom: 0
    },
    '& .MuiTabs-root': {
      minHeight: 54,
      '& .MuiTabs-flexContainer': {
        height: 54
      }
    },
    '& .MuiTabs-indicator': {
      backgroundColor: colorSet.gray900
    },
    '& .MuiTab-root': {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: 'calc(100% / 2)'
      },
      '& .MuiTab-wrapper': {
        '& > span': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }
    }
  }
}));

export default ReviewTabs;
